import { createAction, handleActions } from "redux-actions";

import { api } from "../../services";
import { rootReducerInterface } from "../../typings/interfaces";

const HIDDEN_ADS_IDS_GET = "HIDDEN_ADS_IDS_GET";
const HIDDEN_AD_HIDE = "HIDDEN_AD_HIDE";
const HIDDEN_AD_UNHIDE = "HIDDEN_AD_UNHIDE";

// ACTIONS

// Get hidden ads ids (string[])
export const getHiddenAdIds = createAction(
  HIDDEN_ADS_IDS_GET,
  async () => {
    try {
      const hiddenAdIds = await api.Ads.hiddenAds();
      return hiddenAdIds;
    } catch (error) {
      return null;
    }
  }
);


// Hide ad action
export const hideAd = createAction(
  HIDDEN_AD_HIDE,
  async (adId: string) => {
    try {
      await api.Ads.hideAd(adId);
      return adId;
    } catch (error) {
      throw error;
    }
  }
);

// Unhide ad action
export const unhideAd = createAction(
  HIDDEN_AD_UNHIDE,
  async (adId: string) => {
    try {
      await api.Ads.unhideAd(adId);
      return adId;
    } catch (error) {
      throw error;
    }
  }
);

// SELECTORS
export const selectHiddenAdIds = (state: rootReducerInterface) =>
  state.hidden && state.hidden.hiddenAdIds ? state.hidden.hiddenAdIds : [];

// INITIAL STATE
const initialState = {
  hiddenAdIds: [],
};

// REDUCERS
const hiddenAdsReducers = {
  setHiddenAdIds: (state: any, { payload }) => ({
    ...state,
    hiddenAdIds: !payload ? [] : [...payload]
  }),
  hideAd: (state: any, { payload }) => ({
    ...state,
    hiddenAdIds: payload && !state.hiddenAdIds.includes(payload) 
      ? [...state.hiddenAdIds, payload] 
      : state.hiddenAdIds
  }),
  unhideAd: (state: any, { payload }) => ({
    ...state,
    hiddenAdIds: payload ? state.hiddenAdIds.filter((id: string) => id !== payload) : state.hiddenAdIds
  })
};

export default handleActions(
  {
    [HIDDEN_ADS_IDS_GET]: hiddenAdsReducers.setHiddenAdIds,
    [HIDDEN_AD_HIDE]: hiddenAdsReducers.hideAd,
    [HIDDEN_AD_UNHIDE]: hiddenAdsReducers.unhideAd
  },
  initialState
);


// WEBPACK FOOTER //
// ./src/routes/Hidden/hidden.ducks.ts